<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <EmployeeRolesTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import EmployeeRolesTableItem from 'components/setting/employeeRoles/EmployeeRolesTableItem'
export default {
  name: 'EmployeeRoles',
  props: ['items'],
  components: { EmployeeRolesTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-employee_roles']['tables'][
            'nazvanie'
          ],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-structure_company']['labels'][
            'vacancies_count'
          ],
        },
        {text: '', active: true},
      ]
    },
  },
}
</script>
